import { withStyles } from '@material-ui/core/styles';
import { MapOutlined } from '@material-ui/icons';
import supportHrefs from 'common/constants/supportHrefs';
import BatteryIcon from 'common/icons/Battery';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import { Divider } from 'evee-ui-common/components/base';
import { Region } from 'evee-ui-common/enums';
import { history } from 'evee-ui-common/services';
import { getHomeUrl } from 'evee-ui-common/utils';
import useRegion from 'store/modules/app/hooks/useRegion';

import { Bolt, Car, File, Gift, Lightbulb, Notebooks, SignIn, UserPlus, Wallet } from '../../icons';
import Item from '../../utils/Item';
import styles from '../styles';

const UnauthorizedItems = ({ classes, onSignUp, onSignIn, onClose }) => {
  const location = useLocation();
  const { region } = useRegion();

  return (
    <>
      <Item
        bold
        label="Sign Up"
        icon={<UserPlus />}
        onClick={() => {
          onSignUp();
        }}
      />

      <Item
        label="Log In"
        icon={<SignIn />}
        onClick={() => {
          onSignIn();
        }}
      />

      <Item
        selected={location.pathname === '/car-host'}
        label="Become a host"
        icon={<Car />}
        onClick={() => {
          history.push('/car-host');
          onClose();
        }}
      />

      <Divider className={classes.divider} />

      <Item
        label="All evee vehicles"
        selected={location.pathname.includes('/vehicles') || location.pathname.includes('/search')}
        icon={<MapOutlined />}
        onClick={() => {
          history.push('/vehicles');
          onClose();
        }}
      />

      <Item
        label="How evee works"
        icon={<Lightbulb />}
        onClick={() => {
          window.location.href = `${getHomeUrl(region)}/renting`;
        }}
      />

      <Item
        label="Rewards program"
        icon={<Bolt />}
        onClick={() => {
          window.location.href = `${getHomeUrl(Region.australia)}/pages/rewards`;
        }}
      />

      <Item
        label="Insurance"
        icon={<File />}
        onClick={() => {
          window.location.href = `${getHomeUrl(region)}/insurance`;
        }}
      />

      <Item
        label="Novated leasing"
        icon={<Wallet />}
        onClick={() => {
          window.location.href = `${getHomeUrl(region)}/pages/novated-leasing`;
        }}
      />

      <Item
        label="Charging guide"
        icon={<BatteryIcon />}
        onClick={() => {
          window.location.href = `${getHomeUrl(region)}/blog/your-evee-intro-guide-to-charging`;
        }}
      />

      <Item
        label="Gift cards"
        icon={<Gift />}
        onClick={() => {
          window.location.href = `${getHomeUrl(region)}/giftcards`;
        }}
      />

      <Divider className={classes.divider} />

      <Item
        label="Get help"
        icon={<Notebooks />}
        onClick={() => {
          window.location.href = supportHrefs[region.id].helpCenter;
        }}
      />
    </>
  );
};

UnauthorizedItems.propTypes = {
  classes: PropTypes.shape({
    divider: PropTypes.string.isRequired,
  }).isRequired,
  onSignUp: PropTypes.func,
  onSignIn: PropTypes.func,
  onClose: PropTypes.func,
};

UnauthorizedItems.defaultProps = {
  onSignUp: () => {},
  onSignIn: () => {},
  onClose: () => {},
};

export default withStyles(styles)(UnauthorizedItems);
